import { Alert, AlertTypography, Link } from '@ace-clublabs/shared-component-library';

export const JuniorAssociateAlert = () => {
  return (
    <Alert severity="error" displayCloseButton={false} className="junior-associate-alert">
      <AlertTypography sx={{ fontSize: '0.875rem !important', color: '#404040' }}>
        You can add family members who are 16-18 years old for free with the annual dues option.{' '}
        <Link
          variant="b3Regular"
          href="https://www.ace.aaa.com/information/forms/junior-associate.html"
          target="_blank"
          className="apply-link"
        >
          Apply online
        </Link>{' '}
        or call{' '}
        <Link variant="b3Regular" href="tel:+18004415008" target="_blank" className="call-link">
          1-800-441-5008
        </Link>
        .
      </AlertTypography>
    </Alert>
  );
};
